import React from "react";
import "./cit-dashboard.styles.css";
import { Component } from "react";

import API from "../../api";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { setSuggestedDirectFactData } from "../../redux/buying-recommendation/buying-recommendation.actions";
import { selectSuggestedDirectFactData } from "../../redux/buying-recommendation/buying-recommendation.selectors";
import {
  selectCitUserCommodity,
  selectUserData,
} from "../../redux/user/user.selectors";
import {
  Table,
  Spin,
  message,
  Button,
  Checkbox,
  Input,
  Typography,
  Row,
  Col,
  Card,
  Dropdown,
  Icon,
  Menu,
  PageHeader,
  Select,
  Modal,
} from "antd";
import {
  setCitData,
  setScreen,
} from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";
import fileDownload from "js-file-download";
import { canUserEdit } from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";

const { Option } = Select;

/**
 *
 * @classdesc The Buying reccomendation tab component.
 * @description Displays a table containing the daily output from the modal
 * @component
 */
class CITDashboard extends Component {
  state = {
    isSpinnerOnTable: true,
    date: "",
    time: "",
    excelCropId: "",
    excelFile: "",
    cropLists: [],
    fileLists: [],
    file: null,
    isModalFileVisible: false,
  };

  /**
   * @function
   * @description Wait until the user logs in so that a valid access token is generated
   * to call the get api for daily recommentation data.
   * @memberof DownloadReport
   */
  waitUntilLogin = () => {
    if (localStorage.getItem("accessToken") != null) {
      this.setState({ isSpinnerOnTable: true });
      API.get("/crop_list", { params: { dp: 0 } }).then((response) => {
        this.setState({
          cropLists: response.data.data.filter((item) =>
            this.props.citUserCommodity.includes(item.crop_id)
          ),
        });
      });
      this.setState({
        isSpinnerOnTable: false,
      });
    } else {
      setTimeout(() => this.waitUntilLogin(), 100);
    }
  };

  componentDidMount() {
    this.waitUntilLogin();
  }

  render() {
    const ConfigOptions = {
      maxCount: 1,
    };
    message.config(ConfigOptions);
    //#endregion
    const handleChange = (value) => {
      API.get("/cit_uploaded_files", {
        params: { crop_id: value },
      })
        .then((response) => {
          this.setState({
            excelCropId: value,
            fileLists: response.data.data.files,
          });
        })
        .catch((error) => {
          console.error("error", error);
        });
    };
    const postfileupload = (e) => {
      this.setState({ isSpinnerOn: true });
      const formData = new FormData();
      formData.append("file", this.state.file);
      formData.append("crop_id", this.state.excelCropId);
      API.post("/cit_upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          //console.log("Response",response.data)
          this.setState({ isSpinnerOn: false });
          if (response.data.status) {
            message.success(response.data.message, 2.5);
            this.setState({ isModalFileVisible: false });
            document.getElementById("uploadCaptureInputFile").value = "";
          } else if (!response.data.status) {
            message.warning(response.data.message, 2.5);
            this.setState({ isModalFileVisible: false });
            document.getElementById("uploadCaptureInputFile").value = "";
          } else {
            message.error("Failed to upload File", 2.5);
            this.setState({ isModalFileVisible: true });
          }
        })
        .catch((err) => {
          this.setState({ isSpinnerOn: false });
          this.setState({ isModalFileVisible: false });
          //console.log(err.headers,"error",err.response.status,"space",err.message)
          document.getElementById("uploadCaptureInputFile").value = "";
          if (err.response.status === 502) {
            message.error("FAILED: Please Refresh the Application", 2.5);
          } else {
            message.error("Failed to upload File", 2.5);
          }
        });
    };
    const confirm = Modal.confirm;
    function submitpopup(e) {
      var upload = document.Uploadform.upload.value;
      if (upload == "") message.warning("Please Select The Files");
      else {
        confirm({
          title: "Do you want to upload these Files?",
          content: "Please Click Submit to Upload the Excel Report",
          okText: "Submit",
          onOk() {
            postfileupload();
            return new Promise((resolve, reject) => {
              setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            }).catch(() => console.log("Oops errors!"));
          },
          onCancel() {},
        });
      }
    }
    return (
      <div
        className="cit-container"
        style={{ height: window.innerHeight - 83 }}
      >
        <Modal
          title="Select Files"
          footer={false}
          visible={this.state.isModalFileVisible}
          onCancel={() => {
            document.getElementById("uploadCaptureInputFile").value = "";
            this.setState({ file: null, isModalFileVisible: false });
          }}
          //className="varaital-modal11"
          style={{
            textAlign: "center",
            height: "400px",
          }}
          width={550}
        >
          {/* <div
            style={{
              fontSize: "15px",
              color: "red",
            }}
          >
            File Name should be in below format : <br />
            Branchname_YYYYMMDD.xlsm (Eg: Jaipur_20XX0101.xlsm)
          </div> */}
          <br></br>
          <div>
            <form
              name="Uploadform"
              style={{
                fontSize: "20px",
                marginBottom: "5px",
                color: "black",
                marginRight: "50px",
              }}
            >
              <input
                type="file"
                id="uploadCaptureInputFile"
                required={true}
                accept=".xlsm"
                name="upload"
                onChange={(event) => {
                  this.setState({ file: event.target.files[0] });
                }}
              />
            </form>
          </div>
          <div className="btn-container">
            <Button
              onClick={submitpopup}
              className="btn-container"
              style={{
                padding: "2px 8px !important",
                width: "fit-content !important",
                backgroundColor: "rgb(32, 52, 106)",
                borderRadius: "20px",
                color: "white",
                position: "absolute",
                bottom: "20%",
                right: "3.5%",
              }}
            >
              Upload
            </Button>
          </div>
        </Modal>
        <div className="dashboard">
          <PageHeader
            title="Commodity Intelligence Tower"
            className="cit-header"
          />
          <Row>
            <Col span={16}>
              <Row>
                {this.state.cropLists &&
                  this.state.cropLists.map((item) => {
                    return (
                      <Col
                        span={5}
                        offset={1}
                        key={item.crop_id}
                        className="item-col"
                      >
                        <Button
                          className="item-btn"
                          onClick={() => {
                            this.props.setCitData(item);
                            this.props.setScreen(1);
                          }}
                        >
                          {item.crop_name}
                        </Button>
                      </Col>
                    );
                  })}
              </Row>
            </Col>
            <Col span={7} offset={1}>
              <Spin spinning={this.state.isSpinnerOnTable}>
                <Card className="cit-card" style={{ width: 250 }}>
                  <h1>Commodity Repositories</h1>
                  <p>
                    <Select
                      defaultValue={
                        this.state.cropLists.length > 0 &&
                        this.state.cropLists[0]?.crop_id
                      }
                      style={{ width: "100%" }}
                      onChange={handleChange}
                      className="cit-select"
                      placeholder="Select Commodity"
                    >
                      {this.state.cropLists &&
                        this.state.cropLists.map((item) => {
                          return (
                            <Option value={item.crop_id} key={item.crop_id}>
                              {item.crop_name}
                            </Option>
                          );
                        })}
                    </Select>
                  </p>
                  <p>
                    <Button
                      type="primary"
                      disabled={
                        canUserEdit(
                          this.props.userData,
                          null,
                          FeatureCodes.ITC_CIT_VIEW
                        ) || this.state.excelCropId == ""
                      }
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        this.setState({ isModalFileVisible: true });
                      }}
                    >
                      Upload File
                    </Button>
                  </p>
                  {this.state.fileLists.length > 0 && (
                    <p>
                      <Select
                        // defaultValue={this.state.fileLists[0]?.filename}
                        style={{ width: "100%" }}
                        onChange={(value) => {
                          this.setState({ excelFile: value });
                        }}
                        className="cit-select"
                        placeholder="Select Report"
                      >
                        {this.state.fileLists &&
                          this.state.fileLists.map((item) => {
                            return (
                              <Option value={item.filename} key={item.filename}>
                                {item.filename}
                              </Option>
                            );
                          })}
                      </Select>
                    </p>
                  )}
                  <p>
                    <Button
                      type="primary"
                      disabled={
                        canUserEdit(
                          this.props.userData,
                          null,
                          FeatureCodes.ITC_CIT_VIEW
                        ) || this.state.excelFile == ""
                      }
                      style={{
                        width: "100%",
                        maxHeight: "",
                      }}
                      onClick={() => {
                        API.get("/cit_download", {
                          params: {
                            crop_id: this.state.excelCropId,
                            filename: this.state.excelFile,
                          },
                          responseType: "arraybuffer",
                        })
                          .then((response) => {
                            console.log(response);
                            fileDownload(
                              response.data,
                              `${this.state.excelFile}`
                            );
                          })
                          .catch((error) => {
                            console.error("error", error);
                          });
                      }}
                    >
                      Download File
                    </Button>
                  </p>
                </Card>
              </Spin>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  citUserCommodity: selectCitUserCommodity,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setScreen: (data) => dispatch(setScreen(data)),
    setCitData: (data) => dispatch(setCitData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CITDashboard);
